// extracted by mini-css-extract-plugin
export default {"box":"ModalBox_box__INR2d"};